import React, { useEffect, useState } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import RateCard from "../../../../../../../Util/RateCard/RateCard";
import { config, PERMISSIONS } from "../../../../../../../config";
import Popup from 'reactjs-popup';
import "./../LeagueGroups.css"
import LeagueGroupsAdd from "../modals/LeagueGroupsAdd.js";
import DataTableComponent from "../../../../../../../Util/DataTable/DataTable";
import { loadColumns, HOSTED_BY, LEAGUE_STATUS, getUrlToPush, TEAM_STATUS } from "../../../../../../../Util/helper";
import add from "../../../../../../../assets/add-icon.svg";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { permissions } from "../../../../../../../Store/reducers/PermissionsReducer";
import { useSelector } from "react-redux";
import { pageTransitions, transitionDuration } from '../../../../../../../Util/PageTransitions';
import { motion } from 'framer-motion';
import useSearchParam from "../../../../../../../hooks/UrlSearchParam";
import WarningDialogue from '../../../../../../../Util/WarningDialogue';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { messages } from '../../../../../../../messages';
import CustomSelect from "../../../../../../../Util/CustomSelect/CustomSelect";

const columns = loadColumns({
  columns: [
    {
      name: 'Team',
      selector: 'name',
      isTeamList: true,
    },
    {
      name: 'Status',
      selector: 'status',
      type: 'status',
    },
    {
      name: 'Win/Loss',
      selector: 'number_wins',
      sortable: false,
      type: 'winLoss',
    },
    {
      name: 'Players',
      selector: 'playersCount',
      sortable: false
    },
    {
      name: 'Captain',
      selector: 'captain_name',
      sortable: false
    },
    {
      name: 'Additional Requests',
      selector: 'additional_request',
      type: 'additional_request',
      sortable: false,
    },
    {
      name: 'Captain Phone',
      selector: 'captain_phone',
      type: 'contact_number',
      sortable: false,
    },
    {
      name: 'Secondary Phone',
      selector: 'captain_secondary_phone',
      sortable: false,
    },
    {
      name: 'Preferred Time',
      selector: 'preferred_time',
      type: 'status',
    },
    {
      name: 'Forfeit Fee',
      selector: 'for_feit_fees',
      sortable: false,
      type: 'for_feit_fees',
    },
    {
      name: 'Forfeit Refund Amt/Status',
      selector: 'refndableAmounts',
      sortable: false,
    },
    {
      name: 'Paid Amount',
      selector: 'total_fees',
      sortable: false,
      type: 'paid_amount_type'
    },
    {
      name: 'Paid Method',
      selector: 'paid_by',
      sortable: false,
      type: 'paid_by_type'
    },
    {
      name: 'Registered By',
      selector: 'registered_by',
      sortable: false,
      type: 'registered_by'
    },
    {
      name: 'Date Joined',
      selector: 'created_at',
      type: 'datetime',
    }
  ]
});
function TeamsListing(props) {
  const [running, setRunning] = useState(false);
  const history = useHistory();
  const [leagueMoney, setLeagueMoney] = useState({
    revenue: 0,
  });
  const permission = useSelector(permissions);
  const [open, setOpen] = useState(false);
  const [teamData, setTeamData] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const [leagueScheduleCount, setLeagueScheduleCount] = useState(0);
  const closeModal = () => {
    setOpen(false);
  }
  const [teamDetail, setTeamDtail] = useState({
    direction: 'desc',
    sort_column: 'created_at',
    page: 1,
    limit: 50,
    status: 'active',
  });
  const [totalPage, setTotalPage] = useState(0);
  const [totalTeamDetail, setTotalTeamDetail] = useState({
  });
  const leagueId = useSearchParam(props.location).get('leagueId');
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');
  const season_name = new URLSearchParams(search).get('season_name');

  const getTotalTeamUsers = () => {
    if (props.leagueInfo.status && ['Active', 'Sign-up', 'Needs Schedule', 'Complete', 'Archive', 'Cancel'].includes(LEAGUE_STATUS[props.leagueInfo.status])) {
      axiosApi.get(`${config.apiUrl}/teams/count/${leagueId}`)
        .then((response) => {
          setTotalTeamDetail(response.data.data);
        })
        .catch((err) => {
        })
    }
  }

  const getTeams = () => {
    setRunning(true);
    axiosApi.get(`${config.apiUrl}/teams/list/${leagueId}`, {
      params: teamDetail
    })
      .then((response) => {
        setTeamData(response.data.data);
        setTotalPage(response.data.total);
      })
      .catch((err) => {

      })
      .finally(() => {
        setRunning(false);
      });
  }

  const getRevenu = () => {
    axiosApi.get(`${config.apiUrl}/misc/league/revenue/${leagueId}`)
      .then((response) => {
        setLeagueMoney(response.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getScheduleStatus = () => {
    axiosApi.get(`${config.apiUrl}/teams/schedule/status/${leagueId}`)
      .then((response) => {
        setLeagueScheduleCount(response.data.data)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleChange = (e) => {
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
      })
    }
    setTeamDtail(stateFunc);
  }

  const checkProperSchedule = () => {
    axiosApi.get(`${config.apiUrl}/teams/check/scheduling/${leagueId}`)
      .then((response) => {
        if (!response.data.properScheduling) {
          setOpenWarningPopup(true);
          setPopUpContent({
            header: 'Confirm',
            description: response.data.message,
            icon: faExclamationTriangle,
            action: () => {
              setOpenWarningPopup(false);
              setTimeout(() => {
                history.push({
                  pathname: `/admin/leagues/teams/league-settings`,
                  search: `?leagueId=${leagueId}&selected=true${(season_id) ? `&season_id=${season_id}` : ''}`,
                })
              }, 100);
            }
          });
        } else {
          history.push(getUrlToPush('create_schedule'), { leagueId, leagueInfo: props.leagueInfo, season_id })
        }
      })
      .catch((err) => {
        history.push(getUrlToPush('create_schedule'), { leagueId, leagueInfo: props.leagueInfo, season_id })
      })

  }

  const checkConflicts = () => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: messages.conflictedFields,
      icon: faExclamationTriangle,
      action: () => {
        setOpenWarningPopup(false);
        setTimeout(() => {
          history.push({
            pathname: `/admin/leagues/teams/weekly-match`,
            search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}&selected=true` : ''}`,
          })
        }, 100);
      }
    });
  }

  useEffect(() => {
    getScheduleStatus();
  }, [])

  useEffect(() => {
    getTotalTeamUsers();
    //eslint-disable-next-line
  }, [props.leagueInfo.status]);

  useEffect(() => {
    getTeams();
    getRevenu();
    //eslint-disable-next-line
  }, [teamDetail.page, teamDetail.limit, teamDetail.direction, teamDetail.sort_column, teamDetail.status])

  const refundForFiet = () => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Confirm',
      description: 'Would you like to refund forfeit fee for all the teams?',
      icon: faExclamationTriangle,
      action: () => {
        setOpenWarningPopup(false);
        axiosApi.get(`${config.apiUrl}/teams/refund-forfiet/${leagueId}`)
          .then((response) => {
            console.log('response', response);
          })
          .catch((err) => {
          })
      }
    });
  }

  const handleStatusChange = (cb) => {
      setTeamDtail((prev) => ({
        ...prev,
        status: cb
      }))
  }

  return (
    <>
      <motion.div className='teamlisting-wrapper' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>

        {
          props.leagueInfo.status &&
          LEAGUE_STATUS[props.leagueInfo.status] !== 'Needs Schedule' &&
          <div className="groups-wrapper">
            <div className="cards-wrapper leagues-card">
              <div className="heading">
                <h2>League Data</h2>
                {
                  totalTeamDetail.showRefundBtn &&
                  <button className="btn btn-primary" onClick={refundForFiet}>Refund Forfeit Fee</button>
                }
              </div>
              <div className="cards-blk admin">
                <RateCard text='Total Teams' value={`${totalTeamDetail.teamCount && totalTeamDetail.waiting ? totalTeamDetail.teamCount - totalTeamDetail.waiting : totalTeamDetail.teamCount ? totalTeamDetail.teamCount : 'N/A'}`} />
                <RateCard text='Total Players' value={totalTeamDetail.playerCount} />
                <RateCard text='Teams Waiting' value={`${(totalTeamDetail && totalTeamDetail.waiting) ? (totalTeamDetail.waiting) : 0}`} />
                <RateCard text='League Status' value={`${totalTeamDetail && totalTeamDetail.league && (LEAGUE_STATUS[totalTeamDetail.league.status] || 'N/A')}`} />
                <RateCard text='Total Revenue' value={`${leagueMoney?.revenue ? `$${leagueMoney?.revenue}` : '$0'}`} />
                {/* <RateCard text='Total Comped' value='$0' /> */}
                {/* <RateCard text='Revenue Outstanding' value='$0' /> */}
                <RateCard text='Host' value={totalTeamDetail && totalTeamDetail.league && (HOSTED_BY[totalTeamDetail.league.hosted_by] || 'N/A')} />
              </div>
            </div>
          </div>
        }
        {
          LEAGUE_STATUS[props.leagueInfo.status] === 'Needs Schedule' &&
          < div className="btn-wrapper">
            <button className="btn" onClick={() => checkProperSchedule()}>Create Schedule</button>
          </div>
        }

        <div className="table-wrapper team-listing-block">
          <div className="heading-blk">
            <div className="left">
              <h2>Teams</h2>
              <p>Select team to view details or modify</p>
            </div>
            {/* <div className="right">
              {Array.isArray(permission) && permission.includes(PERMISSIONS.TEAM_MODIFICATIONS) && LEAGUE_STATUS[props.leagueInfo.status] !== 'Needs Schedule' && <button onClick={() => setOpen(o => !o)}><img src={add} alt='add-team' />Add Team</button>}
            </div> */}
            <div className="right with-btn">
              <CustomSelect className="mh-32"
                uniqueKey={'team-status-key'}
                data={[
                  {
                    id: 'active',
                    name: 'Active'
                  },
                  {
                    id: 'waiting',
                    name: 'Waiting'
                  }
                ]}
                label={'Status'}
                placeholder={teamDetail.status ? TEAM_STATUS[teamDetail.status] : 'Active'}
                onSelect={(e) => e && handleStatusChange(e.id)}
                requestRunning={running}
                selector="name"
              />
              {Array.isArray(permission) && permission.includes(PERMISSIONS.TEAM_MODIFICATIONS) && <button onClick={() => setOpen(o => !o)}><img src={add} alt='add-team' />Add Team</button>}
            </div>
            <Popup open={open} closeOnDocumentClick={false} onClose={closeModal}>
              <LeagueGroupsAdd closeModal={closeModal} leagueData={props?.leagueInfo} league_id={leagueId} scheduleCount={leagueScheduleCount} type='league_groups' getTeams={() => {
                getTotalTeamUsers();
                getTeams();
              }} hosted_by={totalTeamDetail?.league?.hosted_by} conflicts={checkConflicts} />
            </Popup>
          </div>
          <div className="dataTable">
            <DataTableComponent key="table-admin-users"
              disableRowClicked={!Array.isArray(permission) && permission.includes(PERMISSIONS.TEAM_MODIFICATIONS)}
              type={'league_team_info'}
              data={teamData}
              columns={columns}
              onFilterChange={handleChange}
              totalPage={totalPage}
              season_id={season_id}
              season_name={season_name} />
          </div>
        </div>
      </motion.div>
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={popUpContent.action}
        onClose={() => { setOpenWarningPopup(false); }}
      />
    </>
  );
}

export default withRouter(TeamsListing);
